<template lang="html">
  <img @click="openModal" :title="tut_name" src="@/assets/icons/questionmark.png" alt="questionmark icon">
</template>

<script>
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
export default {
  neme: 'Questionmark',
  props: {
    id: {
      required: false,
      type: Number
    },
    toast: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      tut_name: null,
      tut_text: null
    }
  },
  mounted () {
    this.getHelpMessage()
  },
  methods: {
    getHelpMessage () {
      let params = {
        tut_id: this.id
      }
      api.getTutorial(params).then(res => {
        let tut = res.data.data[0]
        this.tut_name = tut.tut_name
        this.tut_text = tut.tut_text
      }).catch(e => {
        console.log(e)
      })
    },
    openModal () {
      console.log('open modal')
      if (this.toast) {
        this.$toast.default(this.tut_text, {
          duration: 20000,
          dismissable: true,
          pauseOnHover: true
        })
      } else {
        let modalData = {
          title: this.tut_name,
          description: this.tut_text
        }
        let params = {
          modalData: modalData,
          component: 'questionmarkModal'
        }
        eventBus.$emit('openModal', params)
      }
    }
  },
  watch: {
    '$route.params.lang': function () {
      this.getHelpMessage()
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  max-height: 14px;
  max-width: 14px;
  margin: auto 5px;
  cursor: pointer;
}
</style>
